export const CreditCardPaymentMethod = "credit_card";
export const InvoicingPaymentMethod = "invoicing";

export const CampaignStyleHostRead = "hostRead";
export const CampaignStyleCampaignAudio = "campaignAudio";

export const CampaignStyleToDisplay = {
  [CampaignStyleHostRead]: "Host-Read",
  [CampaignStyleCampaignAudio]: "Pre-Recorded",
};

export const CampaignStateCreated = "created";
export const CampaignStateInProgress = "inprogress";
export const CampaignStateCompleted = "completed";

export const ProductExchangeTypeNone = "none";
export const ProductExchangeTypeInstructions = "instructions";
export const ProductExchangeTypeMailing = "mailing";

export const PromoCodeTypePodcasterUnique = "podcaster_unique";
export const PromoCodeTypeStandard = "standard";
export const PromoCodeTypeNone = "no";

export const CampaignItemStateAwaitingAudio = "awaiting-audio-upload";
export const CampaignItemStateSent = "sent";
export const CampaignItemStateRunning = "running";
export const CampaignItemStateAccepted = "accepted";
export const CampaignItemStateCompleted = "completed";
export const CampaignItemStatePaused = "paused";
export const CampaignItemStateExpired = "expired";
export const CampaignItemStateDeclined = "declined";

export const ProductExchangeHelpDocURL =
  "https://pod-public-media-files.s3.amazonaws.com/assets/help-docs/SharingProductSamples_RedCircleGuide.pdf";
export const GreatScriptHelpDocURL = "https://TODO.org";

export const DistributionTypeContinuous = "continuous";
export const DistributionTypeDiscrete = "discrete";

export const CampaignDistributionReachDiscrete = "discrete";
export const CampaignDistributionReachNonContinuous = "non_continuous";
export const CampaignDistributionReachContinuous = "continuous";
